import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import DeleteForeverSharp from '@material-ui/icons/DeleteForeverSharp';
import { Link, IconButton, Tooltip } from '@material-ui/core';
import { AttachmentIcon } from '../../icons';
import AttachmentsListSubTitleRow from './AttachmentsListSubTitleRow';

const useStyles = makeStyles(theme => ({
  root: { display: 'flex', paddingBottom: theme.spacing(2) },
  info: {
    display: 'inline-block',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    padding: theme.spacing(0, 2)
  },
  actionButton: {
    marginTop: theme.spacing(-1.25)
  },
  spacer: {
    flexGrow: 1,
    flexShrink: 1
  }
}));

export const AttachmentsListRow = ({
  attachment,
  deleteAttachment,
  editable,
  AttachmentStatusComponent
}) => {
  const classes = useStyles();
  const onDelete = useCallback(
    () =>
      deleteAttachment({
        uploadUri: attachment.uploadUri,
        type: attachment.type
      }),
    [attachment, deleteAttachment]
  );

  const primaryItem = useMemo(
    () => (
      <Link href={attachment.linkUri} target="_blank" rel="noopener noreferrer">
        {attachment.fileName || attachment.linkUri}
      </Link>
    ),
    [attachment.fileName, attachment.linkUri]
  );

  const secondaryItem = useMemo(
    () => <AttachmentsListSubTitleRow attachment={attachment} />,
    [attachment]
  );

  return (
    <div className={classes.root}>
      <AttachmentIcon attachment={attachment} />
      <div className={classes.info}>
        <Tooltip title={attachment.fileName}>{primaryItem}</Tooltip>
        {secondaryItem}
      </div>
      <div className={classes.spacer} />
      {AttachmentStatusComponent && (
        <AttachmentStatusComponent attachment={attachment} />
      )}
      {editable && (
        <div className={classes.actionButton}>
          <IconButton color="secondary" aria-label="delete" onClick={onDelete}>
            <DeleteForeverSharp />
          </IconButton>
        </div>
      )}
    </div>
  );
};

AttachmentsListRow.propTypes = {
  attachment: PropTypes.object.isRequired,
  deleteAttachment: PropTypes.func.isRequired,
  editable: PropTypes.bool,
  AttachmentStatusComponent: PropTypes.func
};

export default AttachmentsListRow;
